const T = 'transparent'
const OUTLINE = '#351827'
const RED = '#ee365b'
const RED_LIGHT = '#ff7188'
const GOLD_DARK = '#7b4a17'
const GOLD = '#e7ad3d'
const GOLD_LIGHT = '#ffe27a'
const STEEL_DARK = '#376e91'
const STEEL = '#79c9e8'
const STEEL_LIGHT = '#d8f6ff'

export const HUD_HEART_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,T,T,T,T,T,T,
    T,OUTLINE,OUTLINE,T,OUTLINE,OUTLINE,T,T,
    OUTLINE,RED_LIGHT,RED,OUTLINE,RED_LIGHT,RED,OUTLINE,T,
    OUTLINE,RED,RED,RED,RED,RED,OUTLINE,T,
    T,OUTLINE,RED,RED,RED,OUTLINE,T,T,
    T,T,OUTLINE,RED,OUTLINE,T,T,T,
    T,T,T,OUTLINE,T,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

const EMPTY_HEART_COLORS = {
  [RED]: '#49414a',
  [RED_LIGHT]: '#716571'
}

function emptyHeartColor(color) {
  return EMPTY_HEART_COLORS[color] || color
}

export const HUD_HALF_HEART_SPRITE = {
  width: HUD_HEART_SPRITE.width,
  height: HUD_HEART_SPRITE.height,
  pixels: HUD_HEART_SPRITE.pixels.map((color, index) => (
    index % HUD_HEART_SPRITE.width < HUD_HEART_SPRITE.width / 2
      ? color
      : emptyHeartColor(color)
  ))
}

function partialHeartSprite(filledColumns) {
  return {
    width: HUD_HEART_SPRITE.width,
    height: HUD_HEART_SPRITE.height,
    pixels: HUD_HEART_SPRITE.pixels.map((color, index) => (
      index % HUD_HEART_SPRITE.width < filledColumns
        ? color
        : emptyHeartColor(color)
    ))
  }
}

export const HUD_QUARTER_HEART_SPRITE = partialHeartSprite(2)
export const HUD_THREE_QUARTER_HEART_SPRITE = partialHeartSprite(6)

export const HUD_EMPTY_HEART_SPRITE = {
  width: HUD_HEART_SPRITE.width,
  height: HUD_HEART_SPRITE.height,
  pixels: HUD_HEART_SPRITE.pixels.map(emptyHeartColor)
}

const BACKPACK_ROWS = [
  '.....OOOOOO.....',
  '....OO....OO....',
  '...OO......OO...',
  '...OOOOOOOOOO...',
  '..OOHHHHHHHHOO..',
  '..OHHLLLLLLHHO..',
  '.OOHHHHHHHHHHOO.',
  '.OHHHHHHHHHHHHO.',
  '.OHHHLLLLLLHHHO.',
  '.OHHHLGGGGLHHHO.',
  '.OHHHLGGGGLHHHO.',
  '.OHHHHHHHHHHHHO.',
  '.OHHDDHHHHDDHHO.',
  '.OHHDDHHHHDDHHO.',
  '..OHHDDDDDDHHO..',
  '...OOOOOOOOOO...'
]

const BACKPACK_PALETTE = {
  '.': T,
  O: OUTLINE,
  H: '#c87537',
  L: '#e8a15d',
  D: '#874323',
  G: GOLD_LIGHT
}

export const HUD_SHOP_BAG_SPRITE = {
  width: 16,
  height: 16,
  pixels: BACKPACK_ROWS.flatMap(row => (
    Array.from(row, pixel => BACKPACK_PALETTE[pixel])
  ))
}

export const HUD_KEY_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,T,T,T,T,T,T,
    T,OUTLINE,OUTLINE,OUTLINE,T,T,T,T,
    OUTLINE,GOLD_LIGHT,T,GOLD,OUTLINE,T,T,T,
    OUTLINE,GOLD_LIGHT,GOLD,GOLD,OUTLINE,T,T,T,
    T,OUTLINE,OUTLINE,GOLD,OUTLINE,OUTLINE,T,T,
    T,T,T,OUTLINE,GOLD,OUTLINE,GOLD_DARK,T,
    T,T,T,T,OUTLINE,GOLD_DARK,OUTLINE,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_DARK_KING_KEY_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    '#d7a6ff','#8d45c7',T,T,T,T,'#8d45c7','#d7a6ff',
    T,'#5b247f','#8d45c7','#8d45c7','#8d45c7','#8d45c7','#5b247f',T,
    T,T,'#5b247f','#b86be8','#d7a6ff','#8d45c7',T,T,
    T,T,'#5b247f','#b86be8','#b86be8','#8d45c7',T,T,
    T,T,T,'#5b247f','#5b247f',T,T,T,
    T,T,T,T,'#b86be8','#8d45c7',T,T,
    T,T,T,T,'#b86be8','#8d45c7','#b86be8',T,
    T,T,T,T,'#5b247f','#5b247f','#5b247f',T,
  ]
}

export const HUD_SWORD_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,T,T,T,T,OUTLINE,T,
    T,T,T,T,T,OUTLINE,STEEL_LIGHT,OUTLINE,
    T,T,T,T,OUTLINE,STEEL_LIGHT,STEEL,OUTLINE,
    T,T,T,OUTLINE,STEEL_LIGHT,STEEL,OUTLINE,T,
    T,T,OUTLINE,STEEL,STEEL_DARK,OUTLINE,T,T,
    T,OUTLINE,GOLD,OUTLINE,OUTLINE,T,T,T,
    OUTLINE,GOLD_DARK,OUTLINE,GOLD,OUTLINE,T,T,T,
    T,OUTLINE,T,OUTLINE,T,T,T,T,
  ]
}

function recolorSprite(sprite, colors) {
  return {
    ...sprite,
    pixels: sprite.pixels.map(color => colors[color] || color)
  }
}

export const HUD_SWORD_MATERIAL_SPRITES = Object.freeze({
  stone_sword: recolorSprite(HUD_SWORD_SPRITE, {
    [STEEL_DARK]: '#55565b',
    [STEEL]: '#898b91',
    [STEEL_LIGHT]: '#c8c9cc'
  }),
  bone_sword: recolorSprite(HUD_SWORD_SPRITE, {
    [STEEL_DARK]: '#8d795c',
    [STEEL]: '#d6c49d',
    [STEEL_LIGHT]: '#fff0c9'
  }),
  diamond_sword: HUD_SWORD_SPRITE,
  ember_sword: recolorSprite(HUD_SWORD_SPRITE, {
    [STEEL_DARK]: '#9c261f',
    [STEEL]: '#ef5a24',
    [STEEL_LIGHT]: '#ffcf45'
  }),
  legendary_sword: recolorSprite(HUD_SWORD_SPRITE, {
    [STEEL_DARK]: '#4f246d',
    [STEEL]: '#9c4fc7',
    [STEEL_LIGHT]: '#efb7ff'
  }),
  royal_sword: recolorSprite(HUD_SWORD_SPRITE, {
    [STEEL_DARK]: '#a45a12',
    [STEEL]: '#f2b72f',
    [STEEL_LIGHT]: '#fff3a3'
  })
})

export const HUD_SHIELD_SPRITE = {
  width: 9,
  height: 9,
  pixels: [
    T,OUTLINE,OUTLINE,OUTLINE,OUTLINE,OUTLINE,OUTLINE,OUTLINE,T,
    OUTLINE,'#d6b552','#315d9c','#315d9c','#315d9c','#315d9c','#315d9c','#d6b552',OUTLINE,
    OUTLINE,'#d6b552','#315d9c','#315d9c','#d6b552','#315d9c','#315d9c','#d6b552',OUTLINE,
    OUTLINE,'#d6b552','#315d9c',STEEL_LIGHT,STEEL_LIGHT,STEEL_LIGHT,'#315d9c','#d6b552',OUTLINE,
    OUTLINE,'#d6b552',STEEL,OUTLINE,OUTLINE,OUTLINE,STEEL,'#d6b552',OUTLINE,
    OUTLINE,'#d6b552','#315d9c',STEEL,STEEL_DARK,STEEL,'#315d9c','#d6b552',OUTLINE,
    T,OUTLINE,'#d6b552','#315d9c',STEEL,'#315d9c','#d6b552',OUTLINE,T,
    T,T,OUTLINE,'#d6b552','#315d9c','#d6b552',OUTLINE,T,T,
    T,T,T,T,OUTLINE,T,T,T,T,
  ]
}

export const HUD_SHIELD_MATERIAL_SPRITES = Object.freeze({
  sun_guard: recolorSprite(HUD_SHIELD_SPRITE, {
    '#315d9c': '#b94f25',
    '#d6b552': '#ffe16a',
    [STEEL]: '#f0a72f',
    [STEEL_DARK]: '#8b3b1f',
    [STEEL_LIGHT]: '#fff4b8'
  })
})

export const HUD_ARROW_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,'#8b5a2b',T,T,T,STEEL_LIGHT,T,
    T,'#8b5a2b',T,T,T,STEEL_LIGHT,OUTLINE,T,
    '#8b5a2b',T,T,T,STEEL_LIGHT,OUTLINE,T,T,
    '#8b5a2b',T,T,STEEL_LIGHT,OUTLINE,T,T,T,
    '#8b5a2b',T,'#8b5a2b',OUTLINE,T,T,T,T,
    T,'#8b5a2b',OUTLINE,T,T,T,T,T,
    T,T,'#d94c4c',OUTLINE,'#d94c4c',T,T,T,
    T,T,T,'#d94c4c',T,T,T,T,
  ]
}

export const HUD_ARROW_MATERIAL_SPRITES = Object.freeze({
  arrow: recolorSprite(HUD_ARROW_SPRITE, {
    [STEEL_LIGHT]: '#9a9b91',
    '#d94c4c': '#56864d'
  }),
  bone_arrow: recolorSprite(HUD_ARROW_SPRITE, {
    '#8b5a2b': '#dfcda8',
    [STEEL_LIGHT]: '#fff0c9',
    '#d94c4c': '#8d795c'
  }),
  crystal_arrow: recolorSprite(HUD_ARROW_SPRITE, {
    '#8b5a2b': '#397f9c',
    [STEEL_LIGHT]: '#aef7ff',
    '#d94c4c': '#4bc8e8'
  }),
  fire_arrow: recolorSprite(HUD_ARROW_SPRITE, {
    '#8b5a2b': '#6e321d',
    [STEEL_LIGHT]: '#ffd447',
    '#d94c4c': '#ff5b21'
  }),
  shadow_arrow: recolorSprite(HUD_ARROW_SPRITE, {
    '#8b5a2b': '#4b2a60',
    [STEEL_LIGHT]: '#e3a5ff',
    '#d94c4c': '#8c3ec2'
  }),
  light_arrow: recolorSprite(HUD_ARROW_SPRITE, {
    '#8b5a2b': '#d49327',
    [STEEL_LIGHT]: '#fff4a8',
    '#d94c4c': '#72d8f2'
  })
})

export const HUD_POTION_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,OUTLINE,OUTLINE,OUTLINE,T,T,T,
    T,T,OUTLINE,'#b9f2ff',OUTLINE,T,T,T,
    T,OUTLINE,OUTLINE,OUTLINE,OUTLINE,OUTLINE,T,T,
    OUTLINE,'#ff9bd0','#ff4f9f','#ff4f9f','#ff9bd0',OUTLINE,T,T,
    OUTLINE,'#ff4f9f','#ff4f9f','#ff4f9f','#ff4f9f',OUTLINE,T,T,
    OUTLINE,'#ff4f9f','#ff9bd0','#ff9bd0','#ff4f9f',OUTLINE,T,T,
    T,OUTLINE,OUTLINE,OUTLINE,OUTLINE,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_COIN_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,GOLD_DARK,GOLD_DARK,T,T,T,T,
    T,GOLD_DARK,GOLD_LIGHT,GOLD,GOLD_DARK,T,T,T,
    GOLD_DARK,GOLD_LIGHT,GOLD,GOLD,GOLD,GOLD_DARK,T,T,
    GOLD_DARK,GOLD,GOLD_LIGHT,GOLD,GOLD,GOLD_DARK,T,T,
    GOLD_DARK,GOLD,GOLD,GOLD,GOLD,GOLD_DARK,T,T,
    T,GOLD_DARK,GOLD,GOLD,GOLD_DARK,T,T,T,
    T,T,GOLD_DARK,GOLD_DARK,T,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_APPLE_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,T,'#5d351b','#2f7d32',T,T,T,
    T,T,'#2f7d32','#5d351b',T,T,T,T,
    T,'#7d1828','#ef3552','#ef3552','#b8203b',T,T,T,
    '#7d1828','#ff6b78','#ef3552','#ef3552','#b8203b','#7d1828',T,T,
    '#7d1828','#ef3552','#ef3552','#ef3552','#ef3552','#7d1828',T,T,
    T,'#7d1828','#ef3552','#ef3552','#7d1828',T,T,T,
    T,T,'#7d1828','#7d1828',T,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_BANANA_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,T,T,T,'#6b4a13',T,T,
    T,T,T,T,'#f5cf3c','#6b4a13',T,T,
    T,T,T,'#f5cf3c','#ffe86a',T,T,T,
    T,T,'#f5cf3c','#ffe86a',T,T,T,T,
    T,'#f5cf3c','#ffe86a',T,T,T,T,T,
    '#6b4a13','#f5cf3c','#f5cf3c','#f5cf3c',T,T,T,T,
    T,'#6b4a13','#6b4a13','#6b4a13',T,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_DRAGON_FRUIT_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,'#36a852',T,'#36a852',T,T,T,
    T,'#36a852','#ff4f9f','#ff4f9f','#36a852',T,T,T,
    '#36a852','#ff4f9f','#fff1ee','#fff1ee','#ff4f9f','#36a852',T,T,
    T,'#ff4f9f','#fff1ee','#351827','#fff1ee','#ff4f9f',T,T,
    '#36a852','#ff4f9f','#fff1ee','#fff1ee','#ff4f9f','#36a852',T,T,
    T,'#36a852','#ff4f9f','#ff4f9f','#36a852',T,T,T,
    T,T,'#36a852',T,'#36a852',T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_GOLDEN_PINEAPPLE_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,'#2f8b45',T,'#2f8b45',T,T,T,
    T,'#2f8b45','#4fbd58','#2f8b45','#4fbd58',T,T,T,
    T,T,'#8a6615','#8a6615',T,T,T,T,
    T,'#8a6615','#ffd84d','#f2b72f','#8a6615',T,T,T,
    T,'#8a6615','#f2b72f','#ffd84d','#8a6615',T,T,T,
    T,'#8a6615','#ffd84d','#f2b72f','#8a6615',T,T,T,
    T,T,'#8a6615','#8a6615',T,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_MOON_MELON_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,'#244f3b','#244f3b','#244f3b',T,T,T,
    T,'#244f3b','#61c96f','#61c96f','#244f3b',T,T,T,
    '#244f3b','#61c96f','#d8f3d0','#d8f3d0','#61c96f','#244f3b',T,T,
    '#244f3b','#61c96f','#d8f3d0','#6b4ca5','#61c96f','#244f3b',T,T,
    '#244f3b','#61c96f','#d8f3d0','#d8f3d0','#61c96f','#244f3b',T,T,
    T,'#244f3b','#61c96f','#61c96f','#244f3b',T,T,T,
    T,T,'#244f3b','#244f3b','#244f3b',T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_WATERMELON_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,'#205f36','#205f36','#205f36',T,T,T,
    T,'#205f36','#55bd58','#55bd58','#205f36',T,T,T,
    '#205f36','#55bd58','#f0445c','#f0445c','#55bd58','#205f36',T,T,
    '#205f36','#55bd58','#f0445c','#351827','#55bd58','#205f36',T,T,
    '#205f36','#55bd58','#f0445c','#f0445c','#55bd58','#205f36',T,T,
    T,'#205f36','#55bd58','#55bd58','#205f36',T,T,T,
    T,T,'#205f36','#205f36','#205f36',T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_GOLDEN_KIWI_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,'#70501f','#70501f','#70501f',T,T,T,
    T,'#70501f','#d6a52f','#f1d45a','#70501f',T,T,T,
    '#70501f','#d6a52f','#fff1a3','#fff1a3','#d6a52f','#70501f',T,T,
    '#70501f','#f1d45a','#fff1a3','#351827','#d6a52f','#70501f',T,T,
    '#70501f','#d6a52f','#fff1a3','#fff1a3','#f1d45a','#70501f',T,T,
    T,'#70501f','#d6a52f','#f1d45a','#70501f',T,T,T,
    T,T,'#70501f','#70501f','#70501f',T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_STAR_FRUIT_SPRITE = {
  width: 8, height: 8, pixels: [
    T,T,T,'#8a6615',T,T,T,T,
    T,T,'#8a6615','#ffe56b','#8a6615',T,T,T,
    '#8a6615','#8a6615','#ffe56b','#ffe56b','#8a6615','#8a6615',T,T,
    T,'#8a6615','#ffe56b','#fff2a3','#8a6615',T,T,T,
    T,T,'#8a6615','#ffe56b','#ffe56b','#8a6615',T,T,
    T,'#8a6615','#ffe56b','#8a6615','#ffe56b','#8a6615',T,T,
    T,'#8a6615','#8a6615',T,'#8a6615','#8a6615',T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_SUN_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,T,GOLD_DARK,T,T,T,T,
    T,GOLD_DARK,T,GOLD,T,GOLD_DARK,T,T,
    T,T,GOLD_DARK,GOLD_DARK,GOLD_DARK,T,T,T,
    GOLD_DARK,GOLD,GOLD,GOLD_LIGHT,GOLD,GOLD,GOLD_DARK,T,
    T,T,GOLD_DARK,GOLD,GOLD_DARK,T,T,T,
    T,GOLD_DARK,T,GOLD,T,GOLD_DARK,T,T,
    T,T,T,GOLD_DARK,T,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}

export const HUD_MOON_SPRITE = {
  width: 8,
  height: 8,
  pixels: [
    T,T,OUTLINE,OUTLINE,T,T,T,T,
    T,OUTLINE,'#d8ddff','#d8ddff',OUTLINE,T,T,T,
    OUTLINE,'#d8ddff','#aeb8ea',OUTLINE,T,T,T,T,
    OUTLINE,'#d8ddff','#aeb8ea',OUTLINE,T,T,T,T,
    OUTLINE,'#d8ddff','#d8ddff','#aeb8ea',OUTLINE,T,T,T,
    T,OUTLINE,'#d8ddff','#aeb8ea','#aeb8ea',OUTLINE,T,T,
    T,T,OUTLINE,OUTLINE,OUTLINE,T,T,T,
    T,T,T,T,T,T,T,T,
  ]
}
